import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef, useRef, useCallback, useImperativeHandle, useEffect } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Range.module.scss.js";
const rangeVariants = cva([styles["range"], "w-full", "bg-transparent"], {
  variants: {
    color: {
      primary: ["text-primary"],
      success: ["text-success"],
      danger: ["text-danger"],
      warning: ["text-warning"],
      inherit: ["text-inherit"]
    },
    disabled: {
      true: ["bg-grayscale-100 opacity-60"],
      false: []
    }
  },
  defaultVariants: {
    disabled: false,
    color: "primary"
  }
});
const setColor = (node) => {
  const value = +node.value;
  const percentage = (value - +node.min) / (+node.max - +node.min) * 100;
  node.style.backgroundImage = `linear-gradient(
    to right,
    currentColor 0%,
    currentColor ${percentage}%,
    var(--form-range-slider-background-color) ${percentage}%,
    var(--form-range-slider-background-color) 100%
)`;
};
const Range = forwardRef((props, ref) => {
  const { color, disabled, className, value, onValueChange, onChange, min = 0, max = 100, ...rest } = props;
  const internalRef = useRef(null);
  const internalRefSetter = useCallback((node) => {
    internalRef.current = node;
    if (node) {
      setColor(node);
    }
  }, []);
  useImperativeHandle(ref, () => internalRef.current, [internalRef]);
  useEffect(() => {
    if (internalRef.current) {
      setColor(internalRef.current);
    }
  }, [value]);
  const handleChange = (e) => {
    onChange == null ? void 0 : onChange(e);
    const _value = +e.target.value;
    onValueChange == null ? void 0 : onValueChange(_value);
    setColor(e.target);
  };
  return /* @__PURE__ */ jsx(
    "input",
    {
      ...rest,
      ref: internalRefSetter,
      type: "range",
      disabled,
      value,
      onChange: handleChange,
      className: twMerge(rangeVariants({ color, disabled, className })),
      min,
      max
    }
  );
});
export {
  Range as default
};
//# sourceMappingURL=Range.js.map
